module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"25\" height=\"25\" viewBox=\"0 0 25 25\"><path fill=\"#F54A0B\" fill-rule=\"nonzero\" d=\"M7.375 10.125l-1.75 1.75L11.25 17.5 23.75 5 22 3.25 11.25 14l-3.875-3.875zM22.5 12.5c0 5.5-4.5 10-10 10s-10-4.5-10-10 4.5-10 10-10c1 0 1.875.125 2.75.375l2-2C15.75.375 14.125 0 12.5 0 5.625 0 0 5.625 0 12.5S5.625 25 12.5 25 25 19.375 25 12.5h-2.5z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/check-circle.svg
// module id = 718
// module chunks = 2